import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width={19}
    height={19}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      d="M14.72 16.7C14.36 17.78 13.37 18.5 12.2 18.5H3.2C1.67 18.5 0.5 17.33 0.5 15.8V14.9H3.2H11.48C11.84 15.98 12.83 16.7 14 16.7H14.72ZM15.8 0.5H5.9C4.37 0.5 3.2 1.67 3.2 3.2V13.1H13.1V14C13.1 14.54 13.46 14.9 14 14.9H14.9V3.2C14.9 2.66 15.26 2.3 15.8 2.3C16.34 2.3 16.7 2.66 16.7 3.2V4.1H18.5V3.2C18.5 1.67 17.33 0.5 15.8 0.5Z"
      fill="#222A5C"
    />
  </svg>,
  "ScriptFilled"
);
